import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("mc_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const fmtMoney = (n) => {
  const v = Number(n || 0);
  return v.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 });
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" }); } catch { return iso; }
};

export const fmtPct = (n) => `${Number(n || 0).toFixed(1)}%`;

export const VEHICLE_STATUS = [
  { value: "purchased", label: "Purchased" },
  { value: "in_transit", label: "In Transit" },
  { value: "repairing", label: "Repairing" },
  { value: "ready", label: "Ready for Sale" },
  { value: "listed", label: "Listed" },
  { value: "sold", label: "Sold" },
];

export const STATUS_STYLES = {
  purchased: "bg-slate-100 text-slate-700 dark:bg-slate-800/80 dark:text-slate-300",
  in_transit: "bg-purple-100 text-purple-700 dark:bg-purple-500/15 dark:text-purple-300",
  repairing: "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300",
  ready: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300",
  listed: "bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-300",
  sold: "bg-slate-200 text-slate-700 dark:bg-slate-700/70 dark:text-slate-300",
};

export const AUCTION_HOUSES = ["Copart", "IAAI", "Manheim", "Adesa", "Private Party"];
export const TITLE_STATUS = ["clean", "salvage", "rebuilt", "lemon", "flood", "missing", "in_transit"];
export const EXPENSE_CATEGORIES = ["rent", "insurance", "advertising", "tools", "equipment", "fuel", "transport", "auction_fees", "office", "utilities", "other"];
export const DOC_CATEGORIES = [
  { value: "vehicle_photo", label: "Vehicle Photo" },
  { value: "damage_photo", label: "Damage Photo" },
  { value: "before", label: "Before Repair" },
  { value: "after", label: "After Repair" },
  { value: "title", label: "Title" },
  { value: "auction_invoice", label: "Auction Invoice" },
  { value: "repair_receipt", label: "Repair Receipt" },
  { value: "emissions", label: "Emissions" },
  { value: "bill_of_sale", label: "Bill of Sale" },
  { value: "buyer_doc", label: "Buyer Document" },
  { value: "other", label: "Other" },
];
